module.exports = __webpack_public_path__ + "202669:9205d1a92be8207f1496/img/Luminary-homepage-3-L-1024x576.258b81c.jpg";